// Picker search boxes filter on EVERY keystroke, including while the keyboard is composing.
//
// The search box of USelectMenu / UInputMenu is Reka's ComboboxInput, which ignores `input`
// events between `compositionstart` and `compositionend` (correct for CJK input methods).
// But phone keyboards with autocorrect / predictive text — iOS in particular, with the
// Slovenian and other Latin layouts — type each word as an ongoing "composition", so the
// list did not filter until the user pressed space or tapped a suggestion (team bug report,
// 2026-10-02). Our locales (sl/en/de/fr/hr) have no IME that needs the deferral.
//
// Fix, app-wide and without touching the ~30 pickers: a capture-phase listener on the
// document stops `compositionstart` before it reaches a combobox search input. Reka then
// never enters its "composing" state, and its normal `input` handler filters as you type.
// Only JS listeners are skipped — the browser's own composition (underline, suggestions)
// is unaffected. Matched by the attributes Reka's ComboboxInput always sets.
const isPickerSearch = (target: EventTarget | null): boolean =>
    target instanceof HTMLInputElement
    && target.getAttribute('role') === 'combobox'
    && target.getAttribute('aria-autocomplete') === 'list'

export const installLiveSearch = () => {
    document.addEventListener('compositionstart', (event) => {
        if (isPickerSearch(event.target)) event.stopPropagation()
    }, true)
}
